import * as fidmarkImport from './fidmark'; export const fidmark = fidmarkImport;
import * as omgImport from './omg'; export const omg = omgImport;
import * as fogImport from './fog'; export const fog = fogImport;